<template>
  <BContainer
    fluid
    class="d-flex justify-content-center vh-100"
  >
    <full-calendar
      ref="fullCalendar"
      class="w-100"
      :options="calendarOptions"
    >
      <template #eventContent="{ view, event }">
        <div class="d-flex flex-column">
          <!-- view.type -->
          <div class="p-1 d-flex justify-content-center justify-content-md-start">
            <BImg
              :src="require('@/assets/images/user/user-1.jpg')"
              rounded="circle"
              alt="Circle image"
              width="24"
              height="24"
            />
            <b
              class="p-1 text-nowrap d-none d-md-block"
              v-text="event.title"
            />
          </div>
          <div v-if="view.type === 'listWeek'">
            <!-- extendedProps -->

            <div v-if="event.extendedProps">
              <div v-if="event.extendedProps.employee">
                {{ event.extendedProps.employee.employee_name }}
              </div>

              <div v-if="event.extendedProps.activity">
                {{ event.extendedProps.activity.activity_name }}
              </div>
            </div>

            <!-- sample content only at list view -->
          </div>
        </div>
      </template>
    </full-calendar>

    <BModal
      id="modalEvent"
      size="xl"
      scrollable
      hide-header
      no-close-on-esc
      no-enforce-focus
      no-close-on-backdrop
      content-class="full-height"
      modal-class="full-height"
      aria-hidden="false"
      role="dialog"
    >
      <ValidationObserver
        ref="formEvent"
      >
        <BRow>
          <BCol
            cols="12"
            md="4"
          >
            <BFormGroup
              label="Date"
              label-for="fDate"
              label-class="font-weight-bolder"
              class="mb-2"
            >
              <BFormInput
                id="fDate"
                v-model="task.date"
                disabled
              />
            </BFormGroup>
          </BCol>
          <BCol
            cols="12"
            md="4"
          >
            <ValidationProvider
              v-slot="{ errors }"
              vid="employee"
              name="employee"
              rules="required"
            >
              <BFormGroup
                label="Employee"
                label-for="fEmployee"
                label-class="font-weight-bolder"
                class="mb-2"
              >
                <VSelect
                  v-model="selected.employee"
                  input-id="fEmployee"
                  label="employee_name"
                  placeholder="search employee here"
                  :options="options.employees"
                  :disabled="fetching.employees"
                  :loading="fetching.employees"
                  :class="{ 'is-invalid': errors.length > 0 }"
                >
                  <template #option="{ employee_name, employee_code }">
                    <div class="d-flex flex-column flex-md-row py-1">
                      <div class="flex-grow-1">
                        <BImg
                          :src="require('@/assets/images/user/user-1.jpg')"
                          rounded="circle"
                          alt="Circle image"
                          width="24"
                          height="24"
                          class="mr-2"
                        />
                        {{ employee_name }}
                      </div>
                      <strong class="min-w-50px">{{ employee_code }}</strong>
                    </div>
                  </template>
                  <template #selected-option="{ employee_name }">
                    <div class="d-flex flex-column flex-md-row">
                      <div class="flex-grow-1">
                        <BImg
                          :src="require('@/assets/images/user/user-1.jpg')"
                          rounded="circle"
                          alt="Circle image"
                          width="24"
                          height="24"
                          class="mr-2"
                        />
                        {{ employee_name }}
                      </div>
                    </div>
                  </template>
                  <template #no-options="">
                    no available employee
                  </template>
                </VSelect>
                <div
                  v-if="(errors.length > 0)"
                  class="invalid-feedback"
                  v-text="errors[0]"
                />
              </BFormGroup>
            </ValidationProvider>
          </BCol>
          <BCol
            cols="12"
            md="4"
          >
            <ValidationProvider
              v-slot="{ errors }"
              vid="activity"
              name="activity"
              rules="required"
            >
              <BFormGroup
                label="Activity"
                label-for="fActivity"
                label-class="font-weight-bolder"
                class="mb-2"
              >
                <VSelect
                  v-model="selected.activity"
                  input-id="fActivity"
                  label="activity_name"
                  placeholder="search activity here"
                  :options="options.activities"
                  :disabled="fetching.activities"
                  :loading="fetching.activities"
                  :class="{ 'is-invalid': errors.length > 0 }"
                >
                  <template #no-options="">
                    no available activity
                  </template>
                </VSelect>
                <div
                  v-if="(errors.length > 0)"
                  class="invalid-feedback"
                  v-text="errors[0]"
                />
              </BFormGroup>
            </ValidationProvider>
          </BCol>
        </BRow>
      </ValidationObserver>
      <template #modal-footer="{ cancel }">
        <div class="w-100 d-flex justify-content-between">
          <div>
            <BButton
              variant="primary"
              @click="addEvent"
            >
              Add Task
            </BButton>
          </div>
          <div>
            <BButton
              variant="outline-dark"
              @click.prevent="discardBtnEvent => preventAriaHidden(discardBtnEvent, cancel)"
            >
              Close Window
            </BButton>
          </div>
        </div>
      </template>
    </BModal>
  </BContainer>
</template>
<script>
import dayGridPlugin from '@fullcalendar/daygrid'
import listPlugin from '@fullcalendar/list'
import timeGridPlugin from '@fullcalendar/timegrid'
import interactionPlugin from '@fullcalendar/interaction'

import MxMisc from '@/mixins/misc'
import MxFormatter from '@/mixins/formatter'

// import multiMonthPlugin from '@fullcalendar/multimonth'
// import samplePlugin from '@/views/shared/sample'

export default {

  name: 'ASMDashboard',

  mixins: [
    MxMisc,
    MxFormatter
  ],

  middleware: ['auth'],

  metaInfo: () => ({
    title: 'Dashboard'
  }),

  data () {
    return {
      fetching: {
        activities: false,
        employees: false
      },
      options: {
        activities: [],
        employees: []
      },
      selected: {
        activity: null,
        employee: null
      },
      task: {
        date: null,
        activity: null,
        employee: null
      },
      calendarOptions: {
        // businessHours: {
        //   // days of week. an array of zero-based day of week integers (0=Sunday)
        //   daysOfWeek: [ 1, 2, 3, 4, 5, 6 ], // Monday - Thursday
        //   startTime: '10:00', // a start time (10am in this example)
        //   endTime: '18:00', // an end time (6pm in this example)
        // },
        // dayMaxEvents: true,
        // selectable: true,
        // droppable: true,
        // views: {
        //   dayGridDay: {
        //     type: 'dayGrid',
        //     duration: { weeks: 1 }
        //   }
        // },
        // events: (fetchInfo, successCallback, failureCallback) => {
        //   return []
        // },
        plugins: [
          // multiMonthPlugin,
          // samplePlugin,
          dayGridPlugin,
          listPlugin,
          timeGridPlugin,
          interactionPlugin // needed for dateClick
        ],
        dayMaxEvents: true,
        headerToolbar: {
          left: 'prev,next today',
          center: 'title',
          right: 'dayGridMonth,dayGridWeek,listWeek'
        },
        validRange: {
          start: '2025-01-01',
          end: '2025-12-31'
        },
        initialView: 'dayGridMonth',
        initialEvents: [
          {
            allDay: true,
            title: 'M.Cardenas',
            start: '2025-03-10T10:00:00',
            end: '2025-03-10T16:00:00',
            editable: false
            // display: 'background'
          }
        ],
        editable: true,
        selectMirror: false,
        weekends: true,
        events: [
          // {
          //   id: 1,
          //   title: 'Task 1',
          //   start: '2025-03-01T13:00:00',
          //   end: '2025-03-07T13:00:00',
          //   // extendedProps: {
          //   //   activityGroup: {},
          //   //   activity: {}
          //   // }
          //   // editable: false
          // },
          // {
          //   id: 2,
          //   title: 'Task 2',
          //   start: '2025-03-17T10:00:00',
          //   end: '2025-03-21T16:00:00'
          //   // editable: true
          // }
        ],
        // datesSet: this.onMonthChanged,
        dateClick: this.onDateClicked
        // select: this.onSelect,
        // eventClick: this.onDateClicked
        // eventMouseEnter
        // eventMouseLeave
        // eventResize

      }
    }
  },

  watch: {
    'selected.employee' (employee) {
      this.task.employee = employee?.id || null
    },

    'selected.activity' (activity) {
      this.task.activity = activity?.id || null
    }
  },

  methods: {

    getActivities () {
      this.fetching.activities = true

      this.options.activities = [
        {
          id: 1,
          activity_name: 'Activity One'
        },
        {
          id: 2,
          activity_name: 'Activity Two'
        }
      ]

      this.fetching.activities = false
    },

    getEmployees () {
      this.fetching.employees = true

      this.options.employees = [
        {
          id: 1,
          employee_code: 'One Code',
          employee_name: 'Employee One'
        },
        {
          id: 2,
          employee_code: 'Two Code',
          employee_name: 'Employee Two'
        }
      ]

      this.fetching.employees = false
    },

    addEvent () {
      const version = Math.floor(Math.random() * 100)

      this.$refs.fullCalendar.calendar.addEvent({
        id: version,
        title: this.selected.employee.employee_name,
        start: this.dateTimeLocalFormatter(this.task.date),
        end: this.dateTimeLocalFormatter(this.task.date),
        extendedProps: {
          employee: this.selected.employee,
          activity: this.selected.activity
        },
        allDay: true,
        editable: false
      })

      // this.task.date = null
      // this.selected.employee = null
      // this.selected.activity = null

      this.$bvModal.hide('modalEvent')
    },

    onDateClicked ({ date }) {
      this.task.date = this.dateFormatter(date)

      this.selected.employee = null
      this.selected.activity = null

      this.getActivities()
      this.getEmployees()

      this.$bvModal.show('modalEvent')
    }
  }
}
</script>
<style>
.fc .fc-daygrid-day-frame, .fc-theme-standard td, .fc-theme-standard th {
  min-height: 150px !important;
  /* min-width: 150px !important; */
}
/* table.fc-scrollgrid-sync-table > tbody > tr > td.fc-day {
  min-width: 150px !important;
} */
</style>
